import { render, staticRenderFns } from "./expertResponseDetailsModal.vue?vue&type=template&id=47dbffde&scoped=true&"
import script from "./expertResponseDetailsModal.vue?vue&type=script&lang=js&"
export * from "./expertResponseDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./expertResponseDetailsModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./expertResponseDetailsModal.vue?vue&type=style&index=1&id=47dbffde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbffde",
  null
  
)

export default component.exports